import React from "react";
import { useTranslation } from "react-i18next";
import AdnPageTitle from "../common/adnPageTitle/AdnPageTitle";
import AdnCard from "../common/adnCard/AdnCard";
import AdnTable from "../common/adnTable/AdnTable";
import { AppRoutes } from "../../AppRoutes";
import { BellOutlined, ExportOutlined } from "@ant-design/icons";
import { Row, Col, Button, Popconfirm, Modal, Form } from "antd";
import { Link } from "react-router-dom";
import { dateFormat } from "../common/GeneralConfigurations";
import moment from "moment";
import AdnDatePicker from "../common/adnDatePicker/AdnDatePicker";

const WelcomeSessionListForm = ({
  title,
  totalRecords,
  employeesList,
  rowSelection,
  setModalVisible,
  modalVisible,
  handleSend,
  setWelcomeSessionDateTime,
  handleWelcomeSessionExcel,
}) => {
  const { t } = useTranslation();
  const [welcomeSessionForm] = Form.useForm();

  const datetimeFormat = "DD-MM-YYYY HH:mm";

  const disabledDate = (current) => {
    const now = moment();
    const currentDate = moment(current).startOf("day");

    return (
      current &&
      (currentDate.isSameOrBefore(now) ||
        (currentDate.isSame(now) && now.isAfter(current)))
    );
  };

  const columns = [
    {
      title: t("welcomeSession.columns.name"),
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <div className="AvatarName">
          <Link
            to={AppRoutes.consultantById.createPath(record.id)}
            target="_blank"
          >
            {text}
          </Link>
        </div>
      ),
    },
    {
      title: t("welcomeSession.columns.phone"),
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: t("welcomeSession.columns.phone2"),
      dataIndex: "phone2",
      key: "phone2",
    },
    {
      title: t("welcomeSession.columns.email"),
      dataIndex: "email",
      key: "email",
    },
    {
      title: t("welcomeSession.columns.admissionDate"),
      dataIndex: "admissionDate",
      key: "admissionDate",
      render: (text, record) => {
        const formattedDate = moment(record.admissionDate).format(dateFormat);
        return <span>{formattedDate}</span>;
      },
    },
  ];

  return (
    <>
      <AdnPageTitle title={title} />
      <AdnCard>
        <Row gutter={16}>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 24 }}
            lg={{ span: 12 }}
            xl={{ span: 12 }}
            xxl={{ span: 12 }}
          >
            <Button
              className="adn-primary-button"
              type="submit"
              onClick={handleWelcomeSessionExcel}
            >
              <ExportOutlined /> {t("welcomeSession.buttons.export")}
            </Button>
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 24 }}
            lg={{ span: 12 }}
            xl={{ span: 12 }}
            xxl={{ span: 12 }}
          >
            <Popconfirm
              title={t("welcomeSession.messages.notifyAllSelectedConsultants")}
              onConfirm={() => setModalVisible(true)}
              okText={t("welcomeSession.buttons.yes")}
              cancelText={t("welcomeSession.buttons.no")}
            >
              <Button
                className="notifyFollowUpEvent adn-primary-button"
                type="submit"
              >
                <BellOutlined /> {t("welcomeSession.buttons.notifyConsultants")}
              </Button>
            </Popconfirm>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <AdnTable
              rowSelection={rowSelection}
              columns={columns}
              data={employeesList}
              totalRecords={totalRecords}
              showPagination={false}
            />
          </Col>
        </Row>
      </AdnCard>
      <Modal
        title={title}
        open={modalVisible}
        onOk={handleSend}
        cancelText={t("welcomeSession.buttons.cancel")}
        okText={t("welcomeSession.buttons.send")}
        onCancel={() => {
          setModalVisible(false);
        }}
      >
        <Form form={welcomeSessionForm} name="form_in_modal">
          <Col span={20}>
            <AdnDatePicker
              label={t("welcomeSession.labels.welcomeSessionDate")}
              placeholder={t("welcomeSession.placeholders.welcomeSessionDate")}
              format={datetimeFormat}
              showTime={true}
              onChange={(datetime) => setWelcomeSessionDateTime(datetime)}
              disabledDate={disabledDate}
            />
          </Col>
        </Form>
      </Modal>
    </>
  );
};

export default WelcomeSessionListForm;
